<template>
  <section class="member-signup custom-margin">
    <div class="row">
      <div class="col-xs-12">
        <h2 class="headline-lg medium">{{ d.unemploymentInsuranceTitle }}</h2>

        <div class="field-wrapper half">
          <label>{{ d.unemploymentInsuranceMember }}*</label>
          <div class="list-inline">
            <label class="radio">
              <input type="radio" name="unemployment-insurance-fund" required="true"
                v-model="values.unemploymentinsurance" @change="ResetValidation('unemploymentinsurance')"
                value="Ftfa" />
              <span class="checklabel">{{ d.unemploymentinsurancememberftfalabel }}</span>
              <span class="checkmark"></span>
            </label>

            <label class="radio">
              <input type="radio" name="unemployment-insurance-fund" required="true"
                v-model="values.unemploymentinsurance" @change="ResetValidation('unemploymentinsurance')"
                value="JaAnden" />
              <span class="checklabel">{{ d.unemploymentinsurancememberanotherlabel }}</span>
              <span class="checkmark"></span>
            </label>

            <label class="radio">
              <input type="radio" name="unemployment-insurance-fund" required="true"
                v-model="values.unemploymentinsurance" @change="ResetValidation('unemploymentinsurance')" value="Nej" />
              <span class="checklabel">{{ d.unemploymentinsurancemembernonelabel }}</span>
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="hasNoFtfa">
      <div class="col-xs-12">
        <div class="field-wrapper half">
          <label>{{ d.unemploymentInsurancePreviousMemberLabel }}*</label>
          <div class="list-inline">
            <label class="radio">
              <input type="radio" name="old-unemployment-insurance-fund" required="true"
                v-model="values.oldUnemploymentinsurance" value="Ftfa" />
              <span class="checklabel">{{ d.unemploymentinsurancememberftfalabel }}</span>
              <span class="checkmark"></span>
            </label>

            <label class="radio">
              <input type="radio" name="old-unemployment-insurance-fund" required="true"
                v-model="values.oldUnemploymentinsurance" value="JaAnden" />
              <span class="checklabel">{{ d.unemploymentinsurancememberanotherlabel }}</span>
              <span class="checkmark"></span>
            </label>

            <label class="radio">
              <input type="radio" name="old-unemployment-insurance-fund" required="true"
                v-model="values.oldUnemploymentinsurance" value="Nej" />
              <span class="checklabel">{{ d.unemploymentinsurancemembernonelabel }}</span>
              <span class="checkmark"></span>
            </label>
          </div>

        </div>
      </div>
    </div>

    <div v-show="otherInsurance" class="row">
      <div class="col-xs-12" style="margin-bottom: 20px;">
        <DropDownWithSearchEndpoint ref="dropdownRef" id="dropdownUnemploymentInsurance"
          endpoint="/umbraco/api/signup/SearchUnemploymentInsuranceList/?search=" execsearch="1"
          :noresults="d.searchNoResults" :label="d.unemploymentInsuranceWhichOne"
          @change="SetValue($event, 'unemploymentInsurancewhichone')" :options="dictionaryData">
        </DropDownWithSearchEndpoint>
        <div class="row">
          <div class="col-sm-6">
            <HelperTip :rte="d.helpertipunemploymentinsurance"></HelperTip>
          </div>
        </div>
      </div>
    </div>


    <!-- UnemploymentForStudents COMPONENT -->
    <!--Too big and stupid to keep in here -->
    <UnemploymentForStudents v-if="values.unemploymentinsurance && !hasFtfa"></UnemploymentForStudents>


    <!-- <div class="row" v-if="values.unemploymentinsurance && !hasFtfa">
      <div class="col-xs-12">
        <div class="field-wrapper half">
          <label>{{ d.unemploymentInsuranceFulltimeParttimeLabel }}*</label>
          <div class="list-inline">
            <label class="radio">
              <input type="radio" name="unemployment-insurance-fund-type" required="true"
                v-model="values.unemploymentinsuranceType" value="Fuldtidsforsikring" />
              <span class="checklabel">{{ d.unemploymentInsuranceFullyInsured }}</span>
              <span class="checkmark"></span>
            </label>

            <label class="radio">
              <input type="radio" name="unemployment-insurance-fund-type" required="true"
                v-model="values.unemploymentinsuranceType" value="Deltidsforsikring" />
              <span class="checklabel">{{ d.unemploymentInsurancePartlyInsured }}</span>
              <span class="checkmark"></span>
            </label>
            <p v-html="d.unemploymentInsuranceFullyPartlyInsuredExplanation"></p>
          </div>

          <div class="input-errors" v-for="error of v$.values.unemploymentinsuranceType.$errors" :key="error.$uid">
            <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">{{
              d.errorunemploymentinsurancetype }}</div>
          </div>
        </div>
      </div>
    </div> -->
  </section>
</template>

<script>
import axios from "axios";
import useVuelidate from "@vuelidate/core";
import DropDownWithSearchEndpoint from "../FormComponents/DropDownWithSearchEndpoint.vue";
import HelperTip from "../FormComponents/HelperTip.vue";
import UnemploymentForStudents from "./UnemploymentForStudents.vue";
export default {
  components: {
    DropDownWithSearchEndpoint,
    HelperTip,
    UnemploymentForStudents,
  },
  setup() {
    // we use vuelidate for validation
    // https://vuelidate-next.netlify.app/
    return { v$: useVuelidate({ $lazy: true }) };
  },
  data: (instance) => {
    return {
      subscriptionType: instance.store.subscriptionType,
      values: instance.store[instance.store.currentCulture].values.personalDetails,
      product: instance.store[instance.store.currentCulture].values.productDetails,
      d: instance.store[instance.store.currentCulture].dictionary,
      culture: instance.store.currentCulture,
      visual: instance.store[instance.store.currentCulture].values.visualDetails,
      dictionaryData: [],
      isLoading: false,
      error: null,
    };
  },
  computed: {
    otherInsurance() {
      return this.values.unemploymentinsurance == "JaAnden" || this.values.oldUnemploymentinsurance == "JaAnden";
    },
    hasFtfa() {
      return this.values.unemploymentinsurance == "Ftfa";
    },
    hasNoFtfa() {
      return this.values.unemploymentinsurance == "Nej";
    },
  },
  methods: {
    async GetDictionaryData() {
      this.isLoading = true;
      this.error = null;

      try {
        const dataresponse = await axios.get("/umbraco/api/signup/SearchUnemploymentInsuranceList/?search=");
        this.dictionaryData = dataresponse.data;
      } catch (error) {
        this.error = "Der opstod en fejl under hentning af data:" + error.message;
        console.error(this.error);
      } finally {
        this.isLoading = false;
      }
    },
    SetValue(event, field) {
      switch (field) {
        case "unemploymentInsurancewhichone":
          this.values.unemploymentInsurancewhichone = event.selectedValue.value;
          break;
      }
    },
    ResetValidation(field) {
      console.log('field', field);
    },
  },
  mounted() {
    this.GetDictionaryData();

    this.emitter.on("culture-change", () => {
      this.values = this.store[this.store.currentCulture].values.personalDetails;
      this.d = this.store[this.store.currentCulture].dictionary;
      this.v$.$reset();
    });
  },
  validations() {
    return this.validations.unemploymentInsurance;
  },
};
</script>

<style scoped lang="postcss">
.input-errors {
  color: red;
  margin-top: -15px;

  +.input-errors {
    margin-top: 0;
  }
}

.no-margin {
  margin-top: 0;
}

.custom-margin {
  padding-top: 50px;
}

.list-inline {
  label.radio {
    margin-right: 31px;
  }
}
</style>
